import { onBeforeUnmount, onMounted, ref } from 'vue';

/**
 * Reactive viewport-width composable. Exposes `width` (px) and `isMobile`
 * (< 768 px, matching --breakpoint-tablet).
 */
export function useViewport() {
  const width = ref(typeof window !== 'undefined' ? window.innerWidth : 1280);
  const isMobile = ref(width.value < 768);

  function onResize() {
    width.value = window.innerWidth;
    isMobile.value = window.innerWidth < 768;
  }

  onMounted(() => {
    window.addEventListener('resize', onResize, { passive: true });
    onResize();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize);
  });

  return { width, isMobile };
}
